import ITranslationProxyService from "./translation_proxy_service_interface";
import {TextTranslation} from "../../../../app-react/services/translation/text-translation";
import {ITranslationService} from "../../../../app-react/services/translation/translation.service.interface";
import BaseService from "../../base/base_service";

interface TranslationProxyServiceParams {
    getTranslationService: () => ITranslationService;
}

export default class TranslationProxyService extends BaseService implements ITranslationProxyService {
    static CLASS = 'TranslationProxyService';


    private _params: TranslationProxyServiceParams;
    init(params: TranslationProxyServiceParams) {
        this._params = params;
    }

    private get translationService(): ITranslationService {
        return this._params.getTranslationService();
    }

    getTranslation(key: string, parameters?: any): TextTranslation {
        return this.translationService.getTranslation(key, parameters);
    }

    translate(key: string, parameters?: any): string {
        return this.translationService.translate(key, parameters);
    }
}